import { Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {Observable} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {delay, distinctUntilChanged} from 'rxjs/operators';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import {AppState} from '@store/app.states';
import {selectAdminTangoState} from '@app/4dm1n/tango-cards/_store/tango-cards.selectors';
import {Column} from 'devextreme/ui/data_grid';
import {State as dashState} from './_store/tango-card.reducers';
import {fuseAnimations} from '@fuse/animations';
import {DxDataGridComponent} from 'devextreme-angular';
import {TangoCardsService} from '@app/4dm1n/tango-cards/_store/tango-cards.service';
import {FuseSidebarService} from '../../../@fuse/components/sidebar/sidebar.service';
import {TangoBalanceService} from '@app/4dm1n/tango-cards/services/tango-balance.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {confirm} from 'devextreme/ui/dialog';

@Component({
    selector: 'app-tango-cards',
    templateUrl: './tango-cards.component.html',
    styleUrls: ['./tango-cards.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: false
})
export class TangoCardsComponent extends OnDestroyMixin implements OnInit {

  @ViewChild(DxDataGridComponent) historyGrid: DxDataGridComponent;

  orderHistoryColumns: Column[] = [];

  // selectAdminTangoState
  dashboardDatas$: Observable<dashState> = this.store.pipe(
    delay(0),
    select(selectAdminTangoState),
    distinctUntilChanged(),
    untilComponentDestroyed(this),
  );
  displayRefund = false;
  refundMode = true;

  fNewCard: FormGroup = new FormGroup({
    label: new FormControl('', [Validators.required]),
    creditCard: new FormGroup({
      number: new FormControl('', [Validators.required]),
      expiration: new FormControl('', [Validators.required]),
      verificationNumber: new FormControl('', [Validators.required]),
    }),
    billingAddress: new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      addressLine1: new FormControl('', [Validators.required]),
      addressLine2: new FormControl('', []),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('QC', [Validators.required]),
      postalCode: new FormControl('', [Validators.required]),
      country: new FormControl('Canada', [Validators.required]),
      emailAddress: new FormControl('gestion+tangoCard@inbe.ca', [Validators.required, Validators.email]),
    })
  });

  fRefund: FormGroup = new FormGroup({
    creditCardToken: new FormControl<string>(null, [Validators.required]),
    amount: new FormControl<number>(2500, [Validators.required]),
  });

  constructor(
    private store: Store<AppState>,
    public tangoCardsService: TangoCardsService,
    private _fuseSidebarService: FuseSidebarService,
    public tangoBalanceService: TangoBalanceService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.orderHistoryColumns = [
      {
        dataField: 'createdAt',
        dataType: 'datetime',
        caption: 'Envoi',
        sortIndex: 0,
        sortOrder: 'desc',
      },
      {
        dataField: 'recipient.email',
      },
      {
        dataField: 'amountCharged.value',
        caption: 'Amount',
        customizeText: (cellInfo) => {
          return `$${cellInfo.value} USD`;
        }
      },
      {
        dataField: 'referenceOrderID',
        visible: false,
      },
      {
        dataField: 'rewardName',
        caption: 'Reward name'
      },
      {
        dataField: 'referenceOrderID',
        caption: 'Reference Order',
        cellTemplate: 'referenceOrderIDTemplate',
      },
    ];

  }

  resendOrder(referenceOrderID: string) {

    console.log(referenceOrderID);
    return confirm(
      `Resend tangocard for reference ${referenceOrderID} ?`,
      'Resend tango Card'
    )
      .then((dialogResult) => {
          if (dialogResult) {
            this.tangoCardsService.resendCard(referenceOrderID);
          }
        }
      );

  }


  displayRefundPopup() {
    this.tangoBalanceService.refreshCreditCards();
    this.displayRefund = true;
  }

  switchRefundMode() {
    this.refundMode = !this.refundMode;
  }

  addCard() {
    this.tangoBalanceService.addCreditCard(this.fNewCard.getRawValue());
    this.refundMode = false;
  }

  creditCardUnregisters(token) {

    confirm(
      'Cannot undo!',
      'Delete credit card ?'
    ).then((dialogResult) => {
      if (dialogResult) {
        this.tangoBalanceService.creditCardUnregisters(token);
      }
    });

  }


  creditCardDeposits() {

    const {creditCardToken, amount} = this.fRefund.getRawValue();

    confirm(
      'Cannot undo - Ask Daniel/Eric if you don\'t know what you are doing....',
      `Add ${amount} USD to credit card ?`
    ).then((dialogResult) => {
      if (dialogResult) {
        this.tangoBalanceService.creditCardDeposits(creditCardToken, amount);
      }
    });

  }
}
